// extracted by mini-css-extract-plugin
export default {"wrapper":"OrderPlasticCard_wrapper__oetQE","footer":"OrderPlasticCard_footer__89YwT"};